import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";
import { instantFromApi } from "../utils/dateTime";
import { Instant, ChronoUnit } from "js-joda";
import { createRedToGreenColor } from "../utils/colorUtils";

@inject("store")
@observer
class SuccessRateIcon extends Component {
  state = {
    loading: false,
    data: null,
  };

  baseCurrency = null;
  counterCurrency = null;
  loadTimerId = null;

  componentDidMount() {
    const { botId, trade } = this.props;

    this.loadTimerId = setTimeout(() => {
      // postpone the loading process to prevent unnecessary calls
      this.loadTimerId = null;

      this.baseCurrency = trade.currencyPair.split("/")[0];
      this.counterCurrency = trade.currencyPair.split("/")[1];

      this.load(botId, this.baseCurrency, this.counterCurrency);
    }, 5000);
  }

  componentWillUnmount() {
    if (this.loadTimerId) clearTimeout(this.loadTimerId);
  }

  async load(botId, baseCcy, counterCcy) {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
        params: {
          botId,
          baseCcy,
          counterCcy,
        },
      });

      let response = await axiosRequest.get("trade/closedByCcyPair");
      this.setState({ data: response.data });
    } catch (e) {
      this.setState({ data: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { trade } = this.props;

    if (!this.state.data || this.state.loading || this.state.data.length < 3) {
      return null;
    }

    const tradeOpenDate = instantFromApi(trade.pendingOpenDate);
    const tradeOpenSeconds = tradeOpenDate.until(Instant.now(), ChronoUnit.SECONDS);

    const value = this.state.data.reduce((acc, closedTrade) => {
      const openDate = instantFromApi(closedTrade.openDate);
      const closeDate = instantFromApi(closedTrade.closeDate);

      const ctOpenSeconds = openDate.until(closeDate, ChronoUnit.SECONDS);

      if (closedTrade.profitTotal > 0 && ctOpenSeconds > tradeOpenSeconds) return acc + 1;

      return acc;
    }, 0);

    const succesRate = (value / this.state.data.length * 100).toFixed(0);
    const color = createRedToGreenColor(succesRate);

    return (
      <div
        title={"Success rate: " + succesRate + "%"}
        className="animated zoomIn"
        style={{
          display: "inline-block",
          backgroundColor: color,
          border: "none",
          padding: "2px",
          marginLeft: "4px",
          marginRight: "4px",
          position: "relative", // dirty!
          top: "-1px", // dirty!
          fontSize: "10px",
          lineHeight: "10px",
          color: "#fff",
        }}
      >
        {succesRate + "%"}
      </div>
    );
  }
}

export default SuccessRateIcon;



// WEBPACK FOOTER //
// ./src/bot/SuccessRateIcon.js